var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryServerless32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Serverless_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Serverless_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-23",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Serverless_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1235784,20.003 C30.1235784,22.838 28.1265784,25.708 24.3095784,25.708 C20.5865784,25.708 18.1435784,23.494 15.8795784,21.107 C15.6815784,20.898 15.0465784,20.206 14.9725784,20.125 C13.9785784,19.039 13.0285784,18.019 12.0165784,17.2 L12.0195784,20.5 L11.0195784,20.501 L11.0145784,16.001 C11.0145784,15.868 11.0665784,15.741 11.1605784,15.647 C11.2545784,15.553 11.3815784,15.5 11.5135784,15.5 L16.0195784,15.496 L16.0195784,16.496 L12.7385784,16.499 C13.7705784,17.348 14.7205784,18.368 15.7105784,19.449 C15.7575784,19.501 16.3555784,20.148 16.5335784,20.343 C18.6325784,22.639 20.9585784,24.708 24.3095784,24.708 C27.6165784,24.708 29.1235784,22.269 29.1235784,20.003 C29.1235784,17.886 27.7485784,15.608 24.7285784,15.608 C21.3015784,15.608 19.2555784,17.306 17.3795784,19.38 C17.2745784,19.261 17.1715784,19.143 17.0655784,19.023 C16.9505784,18.89 16.8325784,18.756 16.7165784,18.623 C18.6785784,16.472 20.9545784,14.608 24.7285784,14.608 L24.7355784,14.608 C24.6215784,13.05 23.6785784,11.5 21.3105784,11.5 L20.8725784,11.5 C20.6905784,11.5 20.5225784,11.401 20.4355784,11.242 C19.3105784,9.212 17.1855784,8 14.7475784,8 C11.1635784,8 8.24757842,10.916 8.24757842,14.5 C8.24757842,14.776 8.02357842,15 7.74757842,15 C6.30757842,15 4.96057842,15.643 4.05357842,16.765 C3.14557842,17.886 2.80257842,19.358 3.11057842,20.803 C3.56857842,22.945 5.57157842,24.5 7.87257842,24.5 L8.94957842,24.5 C9.19157842,24.5 9.43357842,24.483 9.67357842,24.448 C10.1975784,24.372 10.6655784,24.234 11.0615784,24.039 C12.3005784,23.433 13.3195784,22.47 14.3085784,21.379 C14.3785784,21.459 14.4475784,21.537 14.5185784,21.618 C14.6675784,21.791 14.8215784,21.961 14.9735784,22.134 C13.9525784,23.25 12.8475784,24.278 11.5025784,24.937 C11.0125784,25.178 10.4445784,25.346 9.81757842,25.437 C9.53057842,25.479 9.24057842,25.5 8.94957842,25.5 L7.87257842,25.5 C5.10257842,25.5 2.68857842,23.612 2.13257842,21.012 C1.76157842,19.271 2.17757842,17.493 3.27557842,16.136 C4.27157842,14.905 5.70457842,14.15 7.26357842,14.02 C7.51157842,10.107 10.7725784,7 14.7475784,7 C17.4505784,7 19.8245784,8.303 21.1605784,10.5 L21.3105784,10.5 C23.9205784,10.5 25.6365784,12.133 25.7425784,14.683 C28.7445784,15.144 30.1235784,17.654 30.1235784,20.003",
    id: "Serverless_32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryServerless32);
export default __webpack_public_path__ + "static/media/Arch-Category_Serverless_32.82eadfb3512d6d44c284c9b9a9b0aba2.svg";
export { ForwardRef as ReactComponent };